// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"ql_a bhv_rh bhv_tu","ForumSearch__img":"ql_b","ForumSearch__searchAdsAndShoppingAds":"ql_c","ForumSearch__results--empty":"ql_e"};